export default __webpack_public_path__ + "static/media/instagrm.bd323be7.png";